export default __webpack_public_path__ + "d304cb35ca21e8c36180b1c62074e8db.png";